import {
  INITIAL_MESSAGE,
  REMOVE_TASK_MESSAGE,
  UPDATE_TASK_MESSAGE,
} from "../actions/constants";

export enum SocketStatus {
  SUCCESS = "success",
  FAILED = "failed",
  INITIALIZED = "initialized",
  IN_PROGRESS = "in-progress",
}

export type SocketData = {
  status: SocketStatus;
  type: string;
  details?: any;
};

const reducer = (
  state: { tasks: string[]; data: SocketData[] } = { tasks: [], data: [] },
  action: any
): { tasks: string[]; data: SocketData[] } => {
  switch (action.type) {
    case INITIAL_MESSAGE:
      return {
        ...state,
        tasks: [...state.tasks, action.payload.details?.task_id],
        data: [...state.data, action.payload],
      };
    case UPDATE_TASK_MESSAGE:
      return state
        ? {
            ...state,
            tasks: state.tasks
              ? action.payload.status === SocketStatus.FAILED ||
                action.payload.status === SocketStatus.SUCCESS
                ? state.tasks.filter(
                    (task) => task !== action.payload.details?.task_id
                  )
                : state.tasks
              : [],
            data: state.data
              ? state.data.map((data) => {
                  return action.payload.details?.task_id ===
                    data.details?.task_id
                    ? action.payload
                    : data;
                })
              : [],
          }
        : { tasks: [], data: [] };
    case REMOVE_TASK_MESSAGE:
      return state
        ? {
            ...state,
            tasks: state.tasks.filter(
              (task) => action.payload.details?.task_id !== task
            ),
            data: state.data.filter(
              (data) => action.payload !== data.details?.task_id
            ),
          }
        : { tasks: [], data: [] };
    default:
      return state;
  }
};

export default reducer;
